<bzg-modal-header>
    <span class="bz-modal__title">{{'RPA_BOTS.JOB_DETAIL_TITLE' | translate }}</span>
    <bzg-button-icon [icon]="'icon-close'" size="l" [bzgModalClose]="{trigger: 'close'}">
    </bzg-button-icon>
</bzg-modal-header>
<bzg-modal-content>
    <form>
        <h4 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.INFO' | translate }}:
        </h4>
        <p class="info-content">
            {{initialData.Info}}
        </p>
        <h4 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.INPUT_VALUES' | translate }}:
        </h4>
        <div class="json-content">
            <ngx-json-viewer *ngIf="inputArguments" [json]="inputArguments" [expanded]="true"></ngx-json-viewer>
            <p *ngIf="!inputArguments">
                {{'RPA_BOTS.NO_INPUT_VALUES' | translate }}.
            </p>
        </div>
        <h4 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.START_TIME' | translate }}:
        </h4>
        <p>
            {{initialData.StartTime}}
        </p>
        <h4 class="bz-form-label ng-star-insertede bz-space-inset-xs">
            {{'RPA_BOTS.END_TIME' | translate }}:
        </h4>
        <p>
            {{initialData.EndTime}}
        </p>
    </form>
</bzg-modal-content>